import { COLORS } from '@/config/colors';
import { ComponentsOverrides, ComponentsProps, ComponentsVariants } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const divider: {
  defaultProps?: ComponentsProps['MuiDivider'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiDivider'];
  variants?: ComponentsVariants<Theme>['MuiDivider'];
} = {
  styleOverrides: {
    root() {
      return {
        borderColor: COLORS.grey[800]
      };
    }
  }
};
